var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreshdesk3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.001 11.8045C17.001 11.4588 17.001 11.286 17.053 11.132C17.2042 10.6844 17.6028 10.5108 18.0021 10.3289C18.451 10.1244 18.6754 10.0222 18.8978 10.0042C19.1503 9.98378 19.4032 10.0382 19.619 10.1593C19.9051 10.3198 20.1046 10.6249 20.3089 10.873C21.2523 12.0188 21.7239 12.5918 21.8965 13.2236C22.0358 13.7334 22.0358 14.2666 21.8965 14.7764C21.6448 15.6979 20.8495 16.4704 20.2608 17.1854C19.9597 17.5511 19.8091 17.734 19.619 17.8407C19.4032 17.9618 19.1503 18.0162 18.8978 17.9958C18.6754 17.9778 18.451 17.8756 18.0021 17.6711C17.6028 17.4892 17.2042 17.3156 17.053 16.868C17.001 16.714 17.001 16.5412 17.001 16.1955V11.8045Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00098 11.8046C7.00098 11.3694 6.98876 10.9782 6.63689 10.6722C6.50891 10.5609 6.33923 10.4836 5.99989 10.329C5.55099 10.1246 5.32654 10.0224 5.10414 10.0044C4.43689 9.95037 4.0779 10.4058 3.69311 10.8732C2.74973 12.019 2.27804 12.5919 2.10544 13.2237C1.96616 13.7336 1.96616 14.2668 2.10544 14.7766C2.35718 15.6981 3.1525 16.4705 3.74119 17.1856C4.11227 17.6363 4.46675 18.0475 5.10414 17.996C5.32654 17.978 5.55099 17.8757 5.99989 17.6713C6.33923 17.5167 6.50891 17.4394 6.63689 17.3281C6.98876 17.0221 7.00098 16.631 7.00098 16.1957V11.8046Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.001 10.5V9C20.001 5.13401 16.4193 2 12.001 2C7.5827 2 4.00098 5.13401 4.00098 9V10.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.001 17.5C20.001 22 16.001 22 12.001 22",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreshdesk3);
export default __webpack_public_path__ + "static/media/freshdesk-3.678e6d965bc83309e7c5176666ba4597.svg";
export { ForwardRef as ReactComponent };